export default __webpack_public_path__ + "static/media/GOURMET.a68d7379.png";